/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import {
	Container,
	Button,
	Row,
	Col,
	FormGroup,
	Label,
	Input,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Search from '@mui/icons-material/Search';

import { LoaderLista } from '~/components/Loaders';
import { Text } from '~/components/Text';
import { SubHeader } from '~/components/SubHeader';

export default function Suporte() {
	const listagem = [
		{ name: 'Group A', value: 400 },
		{ name: 'Group B', value: 300 },
		{ name: 'Group C', value: 300 },
		{ name: 'Group D', value: 200 },
	];

	const [isMobile, setIsMobile] = useState(false);

	const ColData = (
		<>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<DatePicker
					placeholderText="Data inicial"
					dateFormat="dd/MM/yyyy"
					className="form-control notranslate"
				/>
			</Col>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<DatePicker
					placeholderText="Data final"
					dateFormat="dd/MM/yyyy"
					className="form-control d-block notranslate"
				/>
			</Col>
		</>
	)

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 900); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Suporte',
						link: '/client/suporte',
					},
				]}
			/>
			<Row className="mt-5 mb-3 border-bottom pb-2">
				<Col md="9" className="d-flex aling-items-center">
					<Text size="large">Suporte</Text>
				</Col>
				<Col md="3" className="d-flex justify-content-end">
					<Button color="primary my-0">Novo chamado</Button>
				</Col>
			</Row>

			<Row className="mb-3">
				<Col>
					<Text size="big">Meus chamados</Text>
				</Col>
			</Row>
			<Row>
				<Col>
					<FormGroup>
						<Label className="d-block">Filtrar por período</Label>
						<Row>
							<Col>
								<Button className="w-100 my-0" color="gray">
									Hoje
								</Button>
							</Col>
							<Col>
								<Button className="w-100 my-0" color="gray">
									7 dias
								</Button>
							</Col>
						</Row>
					</FormGroup>
				</Col>
				<Col>
					<FormGroup>
						<Label className="d-block notranslate">Filtrar por data</Label>
						{!isMobile ?
							<Row>
								{ColData}
							</Row>
							: <>{ColData}</>
						}
					</FormGroup>
				</Col>
				<Col>
					<FormGroup>
						<Label className="d-block">Filtrar por Status</Label>
						<Input type="select" />
					</FormGroup>
				</Col>
			</Row>
			<Row className="mt-5">
				<Col>
					<LoaderLista loading={false} lista={listagem} error={null}>
						<BootstrapTable
							data={listagem}
							striped
							tableHeaderClass="tr-none-trans-on-header"
							pagination>
							<TableHeaderColumn dataField="name" isKey dataSort>
								Lote
							</TableHeaderColumn>
							<TableHeaderColumn dataField="value" dataSort>
								Lote
							</TableHeaderColumn>
							<TableHeaderColumn dataField="value" dataSort>
								Lote
							</TableHeaderColumn>
							<TableHeaderColumn dataField="value" dataSort>
								Lote
							</TableHeaderColumn>
							<TableHeaderColumn dataField="value" dataSort>
								Lote
							</TableHeaderColumn>
							<TableHeaderColumn dataField="value" dataSort>
								Lote
							</TableHeaderColumn>
							<TableHeaderColumn
								dataField={
									<Button
										color="primary"
										onClick={() => console.log('Oi')}>
										<Search />
									</Button>
								}
								dataSort>
								Lote
							</TableHeaderColumn>
						</BootstrapTable>
					</LoaderLista>
				</Col>
			</Row>
		</Container>
	);
}
